module.exports = __webpack_public_path__ + "static/media/barbara5.dccb3d78.mp3";